import { convertIGuideHtmlToLatex } from '../ast/util.html-to-latex.js';

const html = String.raw;
function convertHeadingToLatex(component, backlink) {
  const headingHtml = html`
    <h1>${component.envelope.Title}</h1>
    ${backlink ? html`
          <span>
            <b>Find opgaven her:</b>
            <a href="${backlink}"> ${backlink} </a>
          </span>
        `.trim() : ""}
  `;
  return convertIGuideHtmlToLatex(headingHtml, {
    allowAllHeadings: true
  });
}

export { convertHeadingToLatex };
//# sourceMappingURL=atom.heading.js.map
